import { useC6Bank } from "@/app/contexts/C6BankContext";
import { useToast } from "@/view/components/ui/use-toast";

export default function useAuthorizationLinkModal() {
  const { toast } = useToast();
  const { authorization } = useC6Bank();

  const handleCopyLink = async () => {
    if (!authorization?.link) return;

    await navigator.clipboard.writeText(authorization.link);

    toast({
      title: "Link copiado com sucesso",
      variant: "default",
    });
  };

  return {
    authorization,
    handleCopyLink,
  };
}
